import React from "react";
import NumberFormat from "react-number-format";

/* 숫자 콤마 추가 */
export const NumberWithCommas = (x) => {
  if (x) {
    var regexp = /\B(?=(\d{3})+(?!\d))/g;
    return x.toString().replace(regexp, ",");
  } else {
    return x;
  }

};

/* 숫자만 표기 & 콤마 표시 */
export const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
};

/* 전화번호 유효성 체크 */
export const PhoneNumberValidator = (args) => {
  if (/^((01[1|6|7|8|9])[1-9]+[0-9]{6,7})|(010[1-9][0-9]{7})$/.test(args)) {
    return true;
  }
  return false;
};

/* 이메일 유효성 체크 */
export const CheckEmail = (str) => {
  const reg_email = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;

  if (!reg_email.test(str)) {
    return false;
  } else {
    return true;
  }
};

/* 날짜 내림차순 정렬 */
export const DateDescendingOrder = (a, b) => {
  var dateA = new Date(a.createdAt).getTime();
  var dateB = new Date(b.createdAt).getTime();
  return dateA < dateB ? 1 : -1;
};

/* 날짜 내림차순 정렬 */
export const UsedTimeDescendingOrder = (a, b) => {
  var dateA = new Date(a.usedTime).getTime();
  var dateB = new Date(b.usedTime).getTime();
  return dateA < dateB ? 1 : -1;
};

/* 날짜 오름차순 정렬 */
export const DateAscendingOrder = (a, b) => {
  var dateA = new Date(a.createdAt).getTime();
  var dateB = new Date(b.createdAt).getTime();
  return dateA > dateB ? 1 : -1;
};

/* 랭킹 정렬 */
export const RankingOrder = (a, b) => {
  return a.useCount > b.useCount ? 1 : -1;
};

/* 사용횟수 내림차순 정렬 */
export const UseCountDescendingOrder = (a, b) => {
  return a.useCount < b.useCount ? 1 : -1;
};
